import React from "react";

// Reusable informational SEO content. `blocks` = [{ h, p }].
export function SEOContentSection({ heading, blocks = [] }) {
  return (
    <section data-testid="seo-content-section" className="prose-none">
      {heading && (
        <h2 className="font-head font-extrabold text-2xl sm:text-3xl text-slate-900 mb-4">
          {heading}
        </h2>
      )}
      <div className="space-y-5">
        {blocks.map((b, i) => (
          <div key={i}>
            {b.h && (
              <h3 className="font-head font-bold text-lg text-slate-900 mb-1.5">{b.h}</h3>
            )}
            <p className="text-slate-600 text-[15px] leading-relaxed">{b.p}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
